import type { CommentListProps } from '@xing-com/crate-social-types';
import { useHost } from '@xing-com/crate-xinglet';

import { CommentListSkeleton } from '../comment-list-skeleton/comment-list-skeleton';

export type { CommentListProps };

export const CommentList: React.FC<CommentListProps> = (props) => {
  const { XingletLoader } = useHost();

  return (
    <XingletLoader
      name="@xing-com/crate-social-comment-list-xinglet"
      fallback={<CommentListSkeleton />}
      {...props}
    />
  );
};
